import dayjs from 'dayjs'

import { uploadDateSearchTopics } from 'pages/TerritoryPage/components/VideoFilters/consts'

export default function getCustomTopicFormattedUploadDate(uploadDateFromURL) {
  const isCustom = uploadDateFromURL?.startsWith('custom')
  const isToday = uploadDateFromURL === 'today'

  const response = {
    label: '',
    timeRange: {
      timeUnit: '',
      timeValue: 0,
    },
  }

  if (!uploadDateFromURL) {
    response.label = uploadDateSearchTopics[1]?.label
    response.timeRange = {
      timeUnit: 'day',
      timeValue: 7,
    }

    return response
  }

  if (isToday) {
    response.label = uploadDateSearchTopics[0]?.label
    response.timeRange = {
      timeUnit: 'hour',
      timeValue: 24,
    }

    return response
  }

  if (isCustom) {
    const startDate = dayjs(uploadDateFromURL.split('_')[1])
    const endDate = dayjs(uploadDateFromURL.split('_')[2])
    const timeDiffMonth = endDate.diff(startDate, 'month')
    const timeDiffFormatted = timeDiffMonth > 36 ? 36 : timeDiffMonth || 1

    response.label = `${startDate.format('MMM DD')} - ${endDate.format('MMM DD')}`
    response.timeRange = {
      timeUnit: timeDiffFormatted <= 1 ? 'day' : 'month',
      timeValue: timeDiffFormatted <= 1 ? 30 : timeDiffFormatted,
    }

    return response
  }

  const filterValue = uploadDateSearchTopics.find(
    item => item.key === uploadDateFromURL || item.value === uploadDateFromURL
  )

  const uploadDateFromURLParsedInt = parseInt(uploadDateFromURL)

  response.label = filterValue?.label
  response.timeRange = {
    timeUnit: uploadDateFromURLParsedInt <= 1 ? 'day' : 'month',
    timeValue: uploadDateFromURLParsedInt <= 1 ? 30 : uploadDateFromURLParsedInt,
  }

  return response
}
